export interface ApiApplicationGrant {
  app_label: string;
  model: string;
  can_view: boolean;
  can_add: boolean;
  can_change: boolean;
  can_delete: boolean;
}

export interface ApiApplication {
  id: number;
  name: string;
  description: string;
  token_prefix: string;
  allowed_hosts: string[];
  is_active: boolean;
  created_by_name: string | null;
  created_at: string;
  updated_at: string;
  last_used_at: string | null;
  grant_count: number;
  grants?: ApiApplicationGrant[];
}

export interface ApiApplicationCreatePayload {
  name: string;
  description: string;
  allowed_hosts: string[];
  is_active: boolean;
  grants: ApiApplicationGrant[];
}

export interface ApiApplicationCreateResponse extends ApiApplication {
  token: string;
}

export interface ExternalResourceField {
  name: string;
  type: string;
  read_only: boolean;
  nullable: boolean;
}

/** One token-accessible table, from GET /api/api-applications/resources/. */
export interface ExternalResource {
  slug: string;
  app_label: string;
  model: string;
  key: string;
  description: string;
  path: string;
  url: string;
  prefill: boolean;
  methods: string[];
  search_fields: string[];
  filterset_fields: string[];
  ordering_fields: string[];
  default_ordering: string[];
  example_params: Record<string, string | number>;
  fields: ExternalResourceField[];
}

export interface PlaygroundRequest {
  token: string;
  slug: string;
  origin: string;
  id?: string | number | null;
  params?: Record<string, string>;
}

export interface PlaygroundResult {
  request: { method: string; path: string; params: Record<string, string>; origin: string };
  status: number;
  elapsed_ms: number;
  headers: { "content-type": string | null; "retry-after": string | null };
  body: unknown;
}

export const EXTERNAL_INDEX_PATH = "/api/api-applications/external/";
